import {inject, Injectable, signal, WritableSignal} from '@angular/core';
import {StorageService} from './storage.service';
import {StorageKeys} from '../utils/constants/storageKeys';
import {defaultConfig} from '../utils/constants/defaultConfig';
import {Config} from '../models/config';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private storage = inject(StorageService);
  public config: WritableSignal<Config> = signal(defaultConfig);

  constructor() {}

  async loadConfig() {
    const config: Config = await this.storage.get(StorageKeys.CONFIG);
    if (!config) {
      this.config.set(defaultConfig);
      this.storage.set(StorageKeys.CONFIG, this.config());
    } else {
      this.config.set(config);
    }
  }

  updateConfig(config: Config) {
    this.config.set(config);
    this.storage.set(StorageKeys.CONFIG, config);
  }
}
